module.exports = __webpack_public_path__ + "static/media/low-set(1).34be5575.png";